<ng-container *ngIf="patchingItemTreeForm !== null">
  <h3 mat-dialog-title i18n>Editing {{ rootItem.name }}</h3>
  <mat-dialog-content>
    <form>
      <eas-editor-booking-item-tree-booking-type-form *ngIf="patchingItemTreeForm.get('bookingType')"
        [parentFormGroup]="patchingItemTreeForm"
        [itemTreeBookingTypeForm]="getPatchingItemTreeFormControl('bookingType')">
      </eas-editor-booking-item-tree-booking-type-form>

      <eas-editor-booking-item-tree-exam-type-form
        *ngIf="patchingItemTreeForm.get('examType')"
        [parentFormGroup]="patchingItemTreeForm"
        [itemTreeExamTypeForm]="getPatchingItemTreeFormControl('examType')">
      </eas-editor-booking-item-tree-exam-type-form>

      <eas-editor-booking-item-tree-extra-roles-form *ngIf="patchingItemTreeForm.get('extraRoles')"
        [parentFormGroup]="patchingItemTreeForm"
        [itemTreeExtraRolesForm]="getPatchingItemTreeFormControl('extraRoles')">
      </eas-editor-booking-item-tree-extra-roles-form>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="text-center">
      <button mat-button (click)="onCancel()" i18n>Discard</button>
      <button mat-flat-button color="primary" [disabled]="patchingItemTreeForm.invalid" (click)="onSubmit()" i18n>Apply</button>
    </div>
  </mat-dialog-actions>
</ng-container>
